import React, { useState, ChangeEvent, useEffect } from "react";
import Header from "../../components/header/header";
import { Link } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./adminListage.css";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faArrowLeft,
  faPencil,
  faTrashCan,
  faSearch,
  faFilter,
} from "@fortawesome/free-solid-svg-icons";
//import { getUsers } from "../../services/api_user";
//import { deleteUser } from "../../services/api_cadastro_users";
import Swal from "sweetalert2";

import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { blue } from "@mui/material/colors";
import CustomPagination from "../../components/hooks/pagination";
import { getUsers } from "../../services/api_users";
import { deleteUser } from "../../services/api_users_register";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#00C6C1",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const AdminListage = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const itemsPerPageOptions = [5, 10, 20, 50];
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeKey, setActiveKey] = useState(null);
  const [dados, setDados] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isRresponseEmpty, setEmpty] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);

// conexão com o back
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getUsers();
        const sortedData = response.data.sort((a, b) => a.id - b.id);
        setDados(sortedData);
        //console.log(sortedData, 'informações dos usuários');
        setLoading(false);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchData();
  }, []);


//campo de busca 
  useEffect(() => {
    const filterData = () => {
      if (dados && dados.length > 0) {
        const filtered = dados.filter(
          (item) =>
            (item.nome &&item.nome.toLowerCase().includes(searchTerm.toLowerCase())) ||
            //(item.unidade?.nome &&item.unidade?.nome.toLowerCase().includes(searchTerm.toLowerCase())) ||
            //(item.unidade?.id &&item.unidade?.id.toString().includes(searchTerm))||
            (typeof item.username === 'string' && item.username.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (item.id && item.id.toString().includes(searchTerm))
        );

        setFilteredData(filtered);
        setCurrentPage(1);
      } else {
        // Caso os dados estejam vazios ou undefined, limpar os dados filtrados
        setFilteredData([]);
        setCurrentPage(1);
      }
    };

    filterData();
  }, [searchTerm, dados]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = searchTerm
    ? filteredData
      ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
      : []
    : dados
    ? dados.slice(indexOfFirstItem, indexOfLastItem)
    : [];

  const totalPages = Math.ceil(
    (searchTerm
      ? filteredData
        ? filteredData.length
        : 0
      : dados
      ? dados.length
      : 0) / itemsPerPage
  );


  //paginação
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  const handleGoToEdit = (id) => {
    navigate(`/user-cadastrar`, { state: { id } });
  };

  const handleDeleteModal = (id) => {
    Swal.fire({
      title: "Tem certeza de que deseja inativar o registro?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#808B96",
      confirmButtonText: "Inativar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const response = await deleteUser(id);
          //console.log(response);
          if (response && response.data) {
            //console.log(response);
            // Corrigido: Verificar se há response e response.data
            const updatedData = dados.filter((item) => item.id !== id);
            setDados(updatedData);
            setLoading(false);
            return true;
          } else if (response.status === 422) {
            if (response.data) {
              const mensagem = response.data;
              return Swal.showValidationMessage(`${mensagem}`);
            } else if (response.data.errors) {
              const error = response.data.errors;
              return Swal.showValidationMessage(`Erro: ${error}`);
            }
          }
        } catch (error) {
          return Swal.showValidationMessage(`Erro: não foi possível incativar o registro`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value) {
          Swal.fire({
            title: "Inativado!",
            text: "O registro foi inativado com sucesso.",
            icon: "success",
            timer: 2500,
          });
        }
      }
    });
  };

  function ExpansibleRow(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow
          className="table-row"
          sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell />
          <TableCell component="th" scope="row">
            {row.id}
          </TableCell>
          <TableCell>
            {row.username}
          </TableCell>
          <TableCell component="th" scope="row">
            {row.nome}
          </TableCell>
          <TableCell style={{justifyContent: 'flex-end', borderBottom:"none"}} align="left" className="d-flex">
              <button
                className="btn btn-white text-dark border-none"
                onClick={() => handleGoToEdit(row.id)}
                disabled={row.deletedAt !== null}
              >
                <Link>
                  <FontAwesomeIcon icon={faPencil} size="1x" color={row.deletedAt !== null ? "gray" : "#1E90FF"} />
                </Link>
              </button>
              <button
                className="btn btn-white text-dark"
                style={{border: 'none'}}
                onClick={() => handleDeleteModal(row.id)}
                disabled={row.deletedAt !== null}
              >
                <FontAwesomeIcon icon={faTrashCan} size="1x" color={row.deletedAt !== null ? "gray" : "#F08080"} />
              </button>

            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <p>
                  <strong>Código:</strong> {row.id}
                </p>
                <p>
                  <strong>Nome:</strong> {row.nome}
                </p>
                <p>
                  <strong>Email:</strong> {row.username}
                </p>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      <Header title="Usuários" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        <div className="mb-3">
          <div className="mt-1 mb-3 mt-3">
              <Link to={`/user_cadastrar`}>
                <button className="btn btn-light text-dark">
                  <FontAwesomeIcon icon={faPlus} size="1x" color="#006400" />
                </button>
              </Link>
          </div>

          {isLoading ? (
            <></>
          ) : (
            <>
              <Row>
                <Col md={2} className="mb-3">
                  <Form.Group className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faFilter}
                      size="1x"
                      color="#000000"
                      className="mr-2"
                    />

                    <Form.Control
                      as="select"
                      value={itemsPerPage}
                      onChange={handleItemsPerPageChange}
                      className="ml-2"
                    >
                      {itemsPerPageOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={3} className="mb-3 ml-auto">
                  <Form.Group className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faSearch}
                      size="1x"
                      color="#000000"
                      className="mr-2"
                    />

                    <Form.Control
                      type="text"
                      placeholder="Digite para pesquisar"
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="ml-2"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </div>

        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell />
                    <StyledTableCell>Código</StyledTableCell>
                    <StyledTableCell>Usuário</StyledTableCell>
                    <StyledTableCell>Nome</StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentItems.map((item) => (
                    <ExpansibleRow key={item.id} row={item} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {/* Paginação */}
            <Row className="mt-3">
                <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    handlePageChange={handlePageChange}
                />
            </Row>
               
          </>
        )}
      </div>

      {/*
        <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
        isQuestion={modalContent.isQuestion}
        questionAction={modalContent.qFunc}
      />
      */}
    </>
    );
  };
  
  export default AdminListage;